import {
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { OverlappingEntitiesService } from '../../../core/services/overlapping-entities.service';

import { CameraService } from '../../../core/services/camera.service';
import { DataContextService } from '../../../core/services/data-context.service';
import * as Cesium from 'cesium';
import { WindowService } from '../../../core/services/window.service';

function getEntityCoordinates(entity: any): { longitude: number, latitude: number } | null {
  if (entity.centerpoint && typeof entity.centerpoint.longitude === 'number' && typeof entity.centerpoint.latitude === 'number') {
    return { longitude: entity.centerpoint.longitude, latitude: entity.centerpoint.latitude };
  }
  if (typeof entity.longitude === 'number' && typeof entity.latitude === 'number') {
    return { longitude: entity.longitude, latitude: entity.latitude };
  }
  return null;
}

@Component({
  selector: 'app-over-lapping-entities',
  standalone: true,
  imports: [],
  templateUrl: './over-lapping-entities.component.html',
  styleUrl: './over-lapping-entities.component.css',
})
export class OverLappingEntitiesComponent implements OnInit, OnChanges {
  @Input() entities: any[] = [];
  @Input() position: any;
  @Input() geofenceResults: any;

  constructor(
    private overlappingEntitiesService: OverlappingEntitiesService,
    private dataContext: DataContextService,
    private cameraService: CameraService,
    private windowService: WindowService
  ) {}
  _entities: any[] = [];

  ngOnChanges(changes: SimpleChanges): void { }
  ngOnInit(): void {
    this.entities =
      this.entities?.filter(e => {
        if (e.constructor.name === '_FacilityPinMapEntity') {
          return e.buildingMapEntity !== undefined;
        }
        return true;
      });
  }
 
  navigateToBuilding(entity: any) {
    if(entity.type === "ALERT") {
      this.cameraService.runAlert(new MouseEvent('click'), entity?.entity?.object);
    }else if (entity.buildingMapEntity) {
      this.cameraService.useEntityCamera(entity);
      this.overlappingEntitiesService.showOverlappingEntities([], null);
    }else{
      const windowId = 'window-' + entity.id;
      if (!this.windowService.windowIsOpen(windowId)) {
        this.windowService.openWindows[windowId] = '';
        this.cameraService.openDetailsWindow(entity, windowId);
      }
    }
    const entityId = entity.getId?.() ?? entity.id;

    const mapEntity = this.dataContext.getMapEntity(entityId);

    if (!mapEntity) {
      return;
    }

    this.closeOverlappingEntities();
    const coords = getEntityCoordinates(entity);
    if (!coords) {
      return;
    }
    const altitude = 500;
    const destination = Cesium.Cartesian3.fromDegrees(coords.longitude, coords.latitude, altitude);
    this.cameraService.flyTo({
      destination,
      complete: () => {
        if (!entity.isBuildingIncident?.()) {
          entity.goToEntity?.(() => {});
        } else {
          entity.viewDetailsWindow?.(this);
        }
      },
    });
    return;
  }

  closeOverlappingEntities() {
    this.overlappingEntitiesService.showOverlappingEntities([], null);
  }
}
